module.exports = __webpack_public_path__ + "img/iconQuestionMark.96695f79.svg";